import type { IProductPageContent } from '@models/IProductPageContent';
import create from 'zustand';

interface IProductPageContentState {
  readonly productPageContent: IProductPageContent;
  readonly setProductPageContent: (
    productContentData: IProductPageContent
  ) => void;
}
const useProductPageContentStore = create<IProductPageContentState>((set) => ({
  productPageContent: {
    awardsCarousel: undefined,
    breadcrumbs: undefined,
    cardCarousel: undefined,
    customerQuotes: undefined,
    compatibleProducts: undefined,
    extendedWarrantyCTAFeature: undefined,
    featuredImageGallery: undefined,
    includedAccessories: undefined,
    optionalAccessories: undefined,
    productFootnote: undefined,
    productOverview: undefined,
    subheaderStatementCards: undefined,
    tabbedProductsCrossSellList: undefined,
    technicalSpecifications: undefined,
  },
  setProductPageContent: (productContentData: IProductPageContent) =>
    set({ productPageContent: productContentData }),
}));
export default useProductPageContentStore;
